import { createRef, FunctionComponent } from 'react'
import { Transition, TransitionGroup } from 'react-transition-group'
import { ClientOnlyPortal } from '@components/ClientOnly'
import ToastContainer from './ToastContainer'
import ToastController from './ToastController'
import useToast from '@/hooks/useToast'
import { DISPLAY_ITEMS_NUM } from './settings'

const ToastProvider: FunctionComponent = () => {
  const { queue, remove } = useToast()

  const displayToasts = DISPLAY_ITEMS_NUM > 0
    ? queue.slice(0, DISPLAY_ITEMS_NUM)
    : queue

  return (
    <ClientOnlyPortal selector="#toast">
      <ToastContainer hasToasts={Boolean(queue.length)} >
        <TransitionGroup component={null}>
          {
            displayToasts
              .map(toast => {
                const itemRef = createRef()
                return (
                  <Transition
                    appear
                    key={toast.id}
                    mountOnEnter
                    timeout={500}
                    unmountOnExit
                    nodeRef={itemRef}
                  >
                    {transitionState => (
                      <ToastController
                        key={toast.id}
                        toast={toast}
                        remove={remove}
                        transitionState={transitionState}
                        ref={itemRef}
                      />
                    )}
                  </Transition>
                )
              })
          }
        </TransitionGroup>
      </ToastContainer>
    </ClientOnlyPortal>
  )
}

export default ToastProvider
